import { Component } from '@angular/core';
import { CrudService } from 'src/app/services/crud.service';

@Component({
  selector: 'app-rappelez-moi',
  templateUrl: './rappelez-moi.component.html',
  styleUrls: ['./rappelez-moi.component.scss']
})
export class RappelezMoiComponent {

  constructor( public crud: CrudService) {}

  version = 1;
  tel = "";
  email = '';
//------------------------------------
  changeVersion(num: number) {
    this.version = num;
    this.envoyer();
    if(num === 3 ) {
      setTimeout(()=> {
        this.version = 0;
      },3000);
    }
  }
  //---------------------
    envoyer() {

      let message = {
        to: ["contact@sancey-pc.fr"],
        message: {
          subject: `Demande de rappel téléphonique MACE`,
          text: `Demande de rappel téléphonique. Numéro : ${this.tel}. Email : ${this.email}`,
          html: `
              <h3>Demande de rappel téléphonique 
              </h3>
              <p> Numéro de tél : ${this.tel} </p> <p> Email : ${this.email}</p>`
        }
      }
      this.crud.addEmail(message).then(()=>{
      });
    }
}
